export default "__VITE_ASSET__DEPRDPI5__"